module.exports = __webpack_public_path__ + "static/media/8_IndustryCamp.91531c3e.jpg";